import React from 'react';
import { Trans } from '@lingui/macro';
import HeaderTitle from 'containers/HeaderTitle';
import NotFoundIllustration from './404.svg';

export default function NotFound() {
  return (
    <div className="flex justify-center items-center h-full">
      <HeaderTitle i18nId="Not found" />
      <div className="text-center">
        <img src={NotFoundIllustration} style={{ width: '300px' }} className="inline" />
        <h2 className="mt-10 mb-2 text-secondary"><Trans>Not found</Trans></h2>
        <p className="text-tertiary"><Trans>There's nothing here! Seems like you are in the wrong place.</Trans></p>
      </div>
    </div>
  );
}
